module.exports = __webpack_public_path__ + "static/background-1-5cc168ed5b2f175fcfc1b92eeb971a57.jpg";